module.exports = __webpack_public_path__ + "img/CliAcneSet3.0d480010.jpg";